import React, { useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';

import { IconType } from 'react-icons/lib';
import { Link } from 'react-router-dom';

import { Container } from './styles';



interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

interface IAudio {
  url : string;
  title : string;
}

const audios = [
  { url : '/audios/Voz_1.wav', title : '' },
  { url : '/audios/Voz_2.wav', title : '' },
  { url : '/audios/Voz_3.wav', title : '' },
  { url : '/audios/Voz_4.wav', title : '' },
  { url : '/audios/Voz_5.wav', title : '' },
  { url : '/audios/Voz_6.wav', title : '' },
  { url : '/audios/Voz_7.wav', title : '' },
  { url : '/audios/Voz_8.wav', title : '' },
  { url : '/audios/Voz_9.wav', title : '' },
  { url : '/audios/Voz_10.wav', title : '' },
  { url : '/audios/Voz_11.wav', title : '' },
  { url : '/audios/Voz_12.wav', title : '' },
  { url : '/audios/Voz_13.wav', title : '' },
  { url : '/audios/Voz_14.wav', title : '' },
  { url : '/audios/Voz_15.wav', title : '' },
  { url : '/audios/Voz_16.wav', title : '' },
  { url : '/audios/Voz_17.wav', title : '' },
  { url : '/audios/Voz_18.wav', title : '' },
  { url : '/audios/Voz_19.wav', title : '' },
  { url : '/audios/Voz_20.wav', title : '' },
  { url : '/audios/Voz_21.wav', title : '' },
  { url : '/audios/Voz_22.wav', title : '' },
  { url : '/audios/Voz_23.wav', title : '' },
  { url : '/audios/Voz_24.wav', title : '' },
  { url : '/audios/Voz_25.wav', title : '' },
  { url : '/audios/Voz_26.wav', title : '' },
  { url : '/audios/Voz_27.wav', title : '' },
  { url : '/audios/Voz_28.wav', title : '' },
  { url : '/audios/Voz_29.wav', title : '' },
  { url : '/audios/Voz_30.wav', title : '' },
  { url : '/audios/Voz_31.wav', title : '' },
  { url : '/audios/Voz_32.wav', title : '' },
  { url : '/audios/Voz_33.wav', title : '' },
  { url : '/audios/Voz_34.wav', title : '' },
  { url : '/audios/Voz_35.wav', title : '' },
  { url : '/audios/Voz_36.wav', title : '' },
  { url : '/audios/Voz_37.wav', title : '' },
  { url : '/audios/Voz_38.wav', title : '' },
  { url : '/audios/Voz_39.wav', title : '' },
  { url : '/audios/Voz_40.wav', title : '' },
  { url : '/audios/Voz_41.wav', title : '' },
  { url : '/audios/Voz_42.wav', title : '' },
  { url : '/audios/Voz_43.wav', title : '' },
  { url : '/audios/Voz_44.wav', title : '' },
  { url : '/audios/Voz_45.wav', title : '' },
  { url : '/audios/Voz_46.wav', title : '' },
  { url : '/audios/Voz_47.wav', title : '' },
  { url : '/audios/Voz_48.wav', title : '' },
  { url : '/audios/Voz_49.wav', title : '' },
  { url : '/audios/Voz_50.wav', title : '' },
  { url : '/audios/Voz_51.wav', title : '' },

  
]

const AudioPlayer : React.FC<IAudio> = ({ url, title} ) => {

return  <div style={{display:'flex', flexWrap:'wrap', margin:'10px', alignItems: 'center', justifyContent:'flex-start'}}>
<p style={{margin: '5px'}}>{title}</p>
<ReactAudioPlayer
  src={url}
  autoPlay={false}
  controls
/>

</div> 
}

const TendaVozes: React.FC = () => {

useEffect(() => {
  window.scrollTo(0,0);
},[])

  return (
    <>


      <Container>
        <div className="title_div">
        <img className="tenda_title" src="/apoio/tenda/vozes_title.png"/>

        <Link className="tenda_back" to="/tenda-paulo-freire">
          Voltar
        </Link>

        </div>

        <div className="tenda_body">
        
          <p>Clique para ouvir</p>
          {audios.map( (audio,index) => {
           return <AudioPlayer title={`Voz ${index + 1}`} url={audio.url}/>
          })}
        </div>

        <div className="tenda_ground_div">
          <div>
            <img className="tenda_ground" src="/apoio/tenda/canto_tenda.png"/>
            <img className="tenda_image" src="/apoio/tenda/tenda.png"/>
            </div>
        </div>
      </Container>
    </>
  );
};
export default TendaVozes;
